import Module from '@/store/resource/common/module';
import FormCollections from '@/store/resource/formCollections';
import api from '@/factories/api';

let module = new Module(new FormCollections());

module.add('state', {
  formsCountCache: {},
});

module.add('getters', {
  getFormsCount: (state) => (collectionId) => {
    return state.formsCountCache[collectionId] || 0;
  },
});

module.add('mutations', {
  setFormsCount(state, { collectionId, count }) {
    state.formsCountCache = {
      ...state.formsCountCache,
      [collectionId]: count,
    };
  },
  adjustFormsCount(state, { collectionId, delta }) {
    const current = state.formsCountCache[collectionId] || 0;
    const newCount = Math.max(0, current + delta);
    state.formsCountCache = {
      ...state.formsCountCache,
      [collectionId]: newCount,
    };
  },
  clearFormsCount(state, collectionId) {
    const { [collectionId]: _, ...rest } = state.formsCountCache;
    state.formsCountCache = rest;
  },
});

module.add('actions', {
  async loadFormsCount({ commit }, collectionId) {
    if (!collectionId) return 0;

    const params = { obj_id: collectionId, page: 1, per_page: 1 };
    const data = await api().get('form/records', { params });
    const count = data?.count || 0;

    commit('setFormsCount', { collectionId, count });
    return count;
  },
});

export default module.create();
